import {Dispatch, SetStateAction} from 'react'

export type ID = undefined | null | string
export interface Model {
  _id?: ID
}

export type PaginationState = {
  page: number
  items_per_page: number
  total: number
  links?: Array<{label: string; active: boolean; url: string | null; page: number | null}>
}

export type SortState = {
  sort?: string
  order?: 'asc' | 'desc'
}

export type FilterState = {
  filter?: unknown
}

export type SearchState = {
  lookup?: string
}

export type Response<T> = {
  status: string
  data?: T
  pagination?: PaginationState
  errors?:[object]
  errno?: string
}

export type QueryState = PaginationState & SortState & FilterState & SearchState

export type QueryRequestContextProps = {
  state: QueryState
  updateState: (updates: Partial<QueryState>) => void
}

export const initialQueryState: QueryState = {
  page: 1,
  total: 0,
  items_per_page: 10,
}

export const initialQueryRequest: QueryRequestContextProps = {
  state: initialQueryState,
  updateState: () => {},
}

export type QueryResponseContextProps<T> = {
  response?: Response<Array<T>> | undefined
  error?: any
  refetch: () => void
  isLoading: boolean
  query: string
}

export const initialQueryResponse = {refetch: () => {}, isLoading: false, query: ''}

export type ListViewContextProps = {
  selected: Array<ID>
  onSelect: (selectedId: ID) => void
  onSelectAll: () => void
  clearSelected: () => void
  // NULL => (CREATION MODE) | MODAL IS OPENED
  // NUMBER => (EDIT MODE) | MODAL IS OPENED
  // UNDEFINED => MODAL IS CLOSED
  action?: string
  setAction: Dispatch<SetStateAction<string | undefined>>
  itemForUpdate?: Model | null | undefined
  setItemForUpdate: Dispatch<SetStateAction<Model | undefined | null>>
  isAllSelected: boolean
  disabled: boolean
}

export const initialListView: ListViewContextProps = {
  selected: [],
  onSelect: () => {},
  onSelectAll: () => {},
  clearSelected: () => {},
  setItemForUpdate: () => {},
  setAction: () => {},
  isAllSelected: false,
  disabled: false,
}
